<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mx-auto mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Provinsi')}" label="Provinsi">
							<select v-model="models.kodeProvinsi" v-validate="'required'" @change="getCitiesByProvincies(true)" data-vv-name="Provinsi"
								class="form-control">
								<option value="">Pilih Provinsi</option>
								<option v-for="(v,i) in masters.provinces" :value="v.kodeProvinsi" :key="i">
									{{v.namaProvinsi}}
								</option>
							</select>
							<div v-if="errors.has('Provinsi')">
								<p class="text-danger">{{ errors.first('Provinsi') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kota')}" label="Kota">
							<select v-model="models.kotaId" v-validate="'required'" data-vv-name="Kota"
								class="form-control">
								<option value="">Pilih Kota</option>
								<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
									{{v.namaKota}}
								</option>
							</select>
							<div v-if="errors.has('Kota')">
								<p class="text-danger">{{ errors.first('Kota') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kode')}" label="Kode">
							<b-form-input v-model="models.kodeKecamatan" v-validate="'required'" data-vv-name="Kode">
							</b-form-input>
							<div v-if="errors.has('Kode')">
								<p class="text-danger">{{ errors.first('Kode') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							<b-form-input v-model="models.namaKecamatan" v-validate="'required'" data-vv-name="Nama">
							</b-form-input>
							<div v-if="errors.has('Nama')">
								<p class="text-danger">{{ errors.first('Nama') }}</p>
							</div>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';

	export default {
		name: 'FormKecamatan',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					kodeKecamatan: "",
					namaKecamatan: "",
					kodeProvinsi: "",
					kotaId: "",
					createdBy: "",
					modifiedBy: "",
				},
				masters: {
					provinces: [],
					cities: [],
				},
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getProvinces();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`Kecamatan/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.kodeKecamatan = data.kodeKecamatan;
						_.models.kotaId = data.kotaId;
						_.models.kodeProvinsi = data.kota.provinsi.kodeProvinsi;
						_.models.namaKecamatan = data.namaKecamatan;
						_.models.createdBy = data.createdBy;
						_.models.modifiedBy = data.modifiedBy;
						_.getCitiesByProvincies(false);
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			getProvinces() {
				const _ = this
				_.$axios.get('Provinsi')
				.then(res => _.masters.provinces = res.data.data);
			},
			getCitiesByProvincies(reset = true) {
				const _ = this
				_.$axios.get('Kota/ByKodeProvinsi/' + _.models.kodeProvinsi)
				.then(res => {
					if(reset === true){
						_.models.kotaId = "";
					}
					_.masters.cities = res.data.data;
				});
			},
			save() {
				const _ = this;
				const user = JSON.parse(localStorage.getItem('user'));
				_.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						if (!_.$route.params.id) {
							_.models.createdBy = user.name;
							request = _.$axios.post(`Kecamatan`, _.models);
						} else {
							_.models.id = _.$route.params.id;
							_.models.modifiedBy = user.name;
							request = _.$axios.put(`Kecamatan/${_.$route.params.id}`, _.models);
						}
						request
						.then(() => _.$router.push({
							name: _.config.uri
						}))
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
						
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>